import History from '../../views/reservations/History';
import Details from '../../views/reservations/Details';
import Reserve from '../../views/reservations/Reserve';

export default [
    {
        path: '/prenotazioni',
        name: 'reservations.history',
        component: History,
        meta: {requiresAuth: true, showNav: true, showOptionbar: true, headerTitleKey: 'prenotazione.storico'}
    },
    {
        path: '/prenotazioni/dettaglio/:id',
        name: 'reservations.details',
        component: Details,
        meta: {requiresAuth: true, showNav: true, showOptionbar: true, headerTitleKey: 'prenotazione.dettagli'}
    },
    {
        path: '/prenotazioni/prenota-tavolo',
        name: 'reservations.reserve',
        component: Reserve,
        meta: {showNav: true, showOptionbar: true, headerTitleKey: 'prenotazione_tavolo.submit_btn'}
    }
]
